/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpertPricingApiResponse } from '../models/ExpertPricingApiResponse';
import type { SavePricingDto } from '../models/SavePricingDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppPricingService {
    /**
     * Get expert pricing configuration
     * Returns per-session pricing grouped by (service_type_id, session_type) with mode-wise single_session_price values, plus package templates with expert-specific prices (fetch-from-master pattern), and metadata flags (supports_packages, supports_duo, supports_single_session) read from the service_types DB columns. Package templates show all predefined packages for the expert's service type. Each template includes filled/empty prices per mode (null = not yet filled by expert).
     * @returns ExpertPricingApiResponse Pricing fetched successfully
     * @throws ApiError
     */
    public static pricingControllerGetPricingV1(): CancelablePromise<ExpertPricingApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/pricing',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Save pricing configuration
     * Accepts per-session pricing grouped by service/session_type with mode-wise single_session_price values. The request fully replaces existing expert_pricing rows and upserts package pricing in a single transaction. Package pricing is grouped by package_template_id with nested modes[] entries and keyed by (template, mode). New entries create rows in the packages table with package_template_id set, reusing (and reactivating) a previously deactivated row for the same (template, mode) rather than inserting a duplicate. Existing active template-linked packages not included in the payload are soft-deactivated. Validates service-type business rules (single/duo support, package support) from DB columns.
     * @param requestBody
     * @returns ExpertPricingApiResponse Pricing saved successfully
     * @throws ApiError
     */
    public static pricingControllerSavePricingV1(
        requestBody: SavePricingDto,
    ): CancelablePromise<ExpertPricingApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/expert-app/pricing',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or business rule violation`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                409: `Pricing conflicts with an existing package row`,
            },
        });
    }
    /**
     * Deactivate a package
     * Soft-deactivates a package by setting is_active=false. Cannot hard-delete because bookings may reference the package.
     * @param id Package UUID
     * @returns any Package deactivated successfully
     * @throws ApiError
     */
    public static pricingControllerDeactivatePackageV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/expert-app/pricing/packages/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Package is already deactivated`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `Package not found`,
            },
        });
    }
}
